<template>
  <v-app>
    <AlertScreen></AlertScreen>
    <router-view></router-view>
    <LoadingScreen></LoadingScreen>
    <DialogScreen></DialogScreen>
  </v-app>
</template>

<script>
import Vue from 'vue'
import AlertScreen from '@/components/common/AlertScreen/AlertScreen'
import LoadingScreen from '@/components/common/LoadingScreen/LoadingScreen'
import DialogScreen from '@/components/common/DialogScreen/DialogScreen'

export default {
  name: 'App',
  components: {
    AlertScreen,
    LoadingScreen,
    DialogScreen
  },
  created () {
    if (Vue.localStorage.get('token')) {
      if (this.$route.path !== '/login') {
        this.$store.commit('account/setInfo')
      }
    } else {
      // トークンなしの場合権限チェックを行う
    }
  }
}
</script>
